import { useStack } from '@/react/common/stacks/queries/useStack';
import { useHelmValuesPreview } from '@/react/portainer/gitops/queries/useHelmValuesPreview';

export function useMergedValuesFromStackID(stackID?: number) {
  const stackQuery = useStack(stackID);
  const credentialID =
    stackQuery.data?.GitConfig?.Authentication?.GitCredentialID;
  const mergedValuesQuery = useHelmValuesPreview({
    repository: stackQuery.data?.GitConfig?.URL || '',
    valuesFiles: stackQuery.data?.HelmValuesFiles || [],
    reference: stackQuery.data?.GitConfig?.ReferenceName,
    username: stackQuery.data?.GitConfig?.Authentication?.Username,
    password: stackQuery.data?.GitConfig?.Authentication?.Password,
    authorizationType:
      stackQuery.data?.GitConfig?.Authentication?.AuthorizationType,
    gitCredentialID: credentialID,
    stackID,
  });
  return mergedValuesQuery;
}
